module.exports = __webpack_public_path__ + "img/brands-paypal.daa6b59a.svg";